import { Section } from "Components/Section";
import React from "react";
import { LcpAppPageWrapper } from "./LcpWorkflowPageWrapper";

export function ClaimSubmittedPage() {
  return (
    <LcpAppPageWrapper documentTitle="Claim Submitted">
      <Section title="Claim Submitted">
        Thank you for submitting your claim. Our claims team will be in touch
        with any questions and further steps.
      </Section>
    </LcpAppPageWrapper>
  );
}
